import axios from "axios";

export default axios.create({
    //baseURL: "https://api.teid-dev.com/api"
   baseURL: process.env.REACT_APP_API_URL
});
